import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

// Pending delayed "mark read" UI updates keyed by conversation id.
// Opening a chat schedules a 4s local unread clear; marking unread must cancel
// that timeout or the UI snaps back to read while the server is unread.
const pendingReadTimeouts = {};
const suppressReadUntil = {};
export const SUPPRESS_READ_MS = 20000;

const clearPendingReadUpdate = id => {
  if (pendingReadTimeouts[id]) {
    clearTimeout(pendingReadTimeouts[id]);
    delete pendingReadTimeouts[id];
  }
};

const shouldSkipMarkRead = id => {
  const until = suppressReadUntil[id];
  return Boolean(until && Date.now() < until);
};

const commitUnread = (commit, { id, lastSeen, unreadCount }) => {
  commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
    id,
    lastSeen,
    unreadCount: Math.max(Number(unreadCount) || 0, 1),
  });
};

export default {
  markMessagesRead: async ({ commit }, data) => {
    const requestedId = data.id;
    if (shouldSkipMarkRead(requestedId)) return;
    try {
      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      if (shouldSkipMarkRead(id)) {
        const unread = await ConversationApi.markMessagesUnread({ id });
        commitUnread(commit, {
          id,
          lastSeen: unread.data.agent_last_seen_at,
          unreadCount: unread.data.unread_count,
        });
        return;
      }
      clearPendingReadUpdate(id);
      pendingReadTimeouts[id] = setTimeout(() => {
        if (shouldSkipMarkRead(id)) return;
        commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen });
        delete pendingReadTimeouts[id];
      }, 4000);
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      clearPendingReadUpdate(id);
      suppressReadUntil[id] = Date.now() + SUPPRESS_READ_MS;
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commitUnread(commit, { id, lastSeen, unreadCount });
    } catch (error) {
      delete suppressReadUntil[id];
      throwErrorMessage(error);
    }
  },
};
